export enum Permission {
  OrdersV4View = 'orders_v4.view',
  OrdersOperationalDashboardCustomersView = 'orders_operational_dashboard_customers.view',
  OrdersOperationalDashboardCancelOrder = 'orders_operational_dashboard.cancel',
  OrdersOperationalDashboardRescheduleOrder = 'orders_operational_dashboard.reschedule',
  OrdersOperationalDashboardAdjustOrder = 'orders_operational_dashboard.adjust_order',
  OrdersOperationalDashboardAdjustOrderBasketContext = 'orders_operational_dashboard.adjust_order_basket_context',
  OrdersOperationalConnectPlatformView = 'connect_platform.view', // required for Query.connectPlatformServiceGetRequestContexts
}
